
/**
 * Calculates elapsed time based on start time and pause duration
 * @returns Updated elapsed time in seconds
 */
export const calculateElapsedTime = (
  startTime: number,
  isPaused: boolean,
  totalPauseDuration: number
): number => {
  // Don't recalculate if timer is paused
  if (isPaused) return 0;
  
  try {
    const now = Date.now();
    const pauseAdjustment = totalPauseDuration || 0;
    const elapsed = Math.floor(((now - startTime) - pauseAdjustment) / 1000);
    // Ensure we never return negative values
    return Math.max(0, elapsed);
  } catch (error) {
    console.error("Error calculating elapsed time:", error);
    return 0;
  }
};
